module.exports = __webpack_public_path__ + "static/media/twoColumns.7b9d0821.svg";